import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { ResumeContextService, ResumeFlow } from 'src/app/services/resume-context.service';
import { ResumeErrorService } from 'src/app/services/resume-error.service';
import {
  ResumeQuoteSummary,
  ResumeService,
} from 'src/app/services/resume.service';

type ResumePaymentProvider = 'mercadopago' | 'gnet' | 'flow';

export const DEFAULT_RESUME_PAYMENT_PROVIDER: ResumePaymentProvider = 'mercadopago';

export const RESUME_PAYMENT_PROVIDERS: ReadonlyArray<{
  id: ResumePaymentProvider;
  name: string;
  description: string;
  logo: string;
}> = [
  {
    id: 'mercadopago',
    name: 'Mercado Pago',
    description: 'Transferencias, tarjetas de crédito y débito',
    logo: 'assets/img/logos/mercadopago.svg',
  },
  {
    id: 'gnet',
    name: 'Getnet',
    description: 'Tarjetas de crédito y débito',
    logo: 'assets/img/logos/getnet-logo.svg',
  },
  {
    id: 'flow',
    name: 'Flow',
    description: 'Tarjetas de crédito y débito',
    logo: 'assets/img/logos/flow.svg',
  },
];

@Component({ selector: 'app-resume', templateUrl: './resume.component.html', styleUrls: ['./resume.component.css'] })
export class ResumeComponent implements OnInit, OnDestroy {
  flow: ResumeFlow | null = null;
  ready = false;
  token = '';
  summary: ResumeQuoteSummary | null = null;
  readonly paymentProviders = RESUME_PAYMENT_PROVIDERS;
  selectedPaymentProvider: ResumePaymentProvider = DEFAULT_RESUME_PAYMENT_PROVIDER;
  acceptTerms = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly resumeService: ResumeService,
    private readonly resumeContext: ResumeContextService,
    private readonly resumeError: ResumeErrorService,
    private readonly spinner: NgxSpinnerService,
    private readonly reCaptchaV3Service: ReCaptchaV3Service,
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';
    this.spinner.show();
    this.resumeService.resolve(this.token).subscribe({
      next: ({ flow }) => {
        this.flow = flow;
        this.resumeContext.setFlow(flow);
        this.selectedPaymentProvider = DEFAULT_RESUME_PAYMENT_PROVIDER;
        this.resumeService.recover(this.token, flow).subscribe({
          next: (response) => {
            this.summary = response;
            this.ready = true;
            this.spinner.hide();
          },
          error: () => this.fail(),
        });
      },
      error: () => this.fail(),
    });
  }

  ngOnDestroy(): void { this.resumeContext.setFlow(null); }

  selectPaymentProvider(provider: ResumePaymentProvider): void {
    this.selectedPaymentProvider = provider;
  }

  continuePayment(): void {
    if (!this.flow || !this.token || !this.acceptTerms) {
      return;
    }

    this.spinner.show();
    this.reCaptchaV3Service.execute(this.selectedPaymentProvider).subscribe({
      next: (recaptcha: string) => {
        this.resumeService.initPayment(this.token, this.selectedPaymentProvider, recaptcha, this.acceptTerms).subscribe({
          next: (response) => {
            this.spinner.hide();
            if (this.selectedPaymentProvider !== 'mercadopago' && response.token) {
              globalThis.location.href = `${response.url}?token=${response.token}`;
              return;
            }
            globalThis.location.href = response.url;
          },
          error: () => this.fail(),
        });
      },
      error: () => this.fail(),
    });
  }

  private fail(): void {
    this.spinner.hide();
    this.ready = false;
    this.summary = null;
    this.resumeContext.setFlow(null);
    void this.router.navigateByUrl('/').then(() => this.resumeError.show());
  }
}
